


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Toast from '@/shared/services/toast';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { googleBmApi } from '@/features/apps/googlebm/services/googlebmApi';
import {AgentTableRow} from '@/features/apps/googlebm/models/agentTableRow';
import {LaunchStatus} from '@/features/apps/googlebm/models/launchStatus';

@Component({})
export default class GoogleBmUnlaunchModal extends Vue {
	@Getter public currentWorkspace: WorkspaceViewModel;

	@Prop() public item!: AgentTableRow;

	@Prop() public loading!: boolean;

	public async unlaunchAgent(): Promise<void> {
		if (this.loading || !this.item) {
			return;
		}
		this.loading = true;
		try {
			const result = await this.sendUnlaunchRequest();

			this.item.launchStatus = result.launchState;
			Toast.showSuccess(`${this.itemTitle} unlaunched`);
			this.$emit('unlaunch', result.launchState);
		} catch (e) {
			Toast.showError(`${this.itemTitle} failed to unlaunch: ${e.message}`);
		}
		this.loading = false;
	}

	private sendUnlaunchRequest(): Promise<{ launchState: LaunchStatus }> {
		if (this.item.rowType === 'agent') {
			return googleBmApi.unlaunchAgent(this.currentWorkspace.id, this.item.customAgentId);
		} else {
			return googleBmApi.unlaunchLocation(this.currentWorkspace.id, this.item.locationId);
		}
	}

	public get itemTitle(): string {
		return this.item.rowType === 'agent' ? 'Agent' : 'Location';
	}

	public get displayName(): string {
		return this.item.rowType === 'agent' ? this.item.displayName : this.item.locationName;
	}
}
